import React, { ReactElement } from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { FormGroup } from "../../../utils/FormGroup";
import { Validators } from "../../../utils/FormValidators";
import { CHEVRON_RIGHT_SVG } from "../../../utils/svgs";
import { AppBottomSheet } from "../../Generic/AppBottomSheet";
import { AppButton } from "../../Generic/AppButton";
import { AppIcon } from "../../Generic/AppIcon";
import { AppInput } from "../../Generic/AppInput";

interface Props {
  isOpen: boolean;
  form: FormGroup;
  onChange: (form: FormGroup) => void;
  onSubmit: (form: FormGroup) => void;
  onRequestClose: () => void;
}

export function ContactAgencyBottomSheet(props: Props): ReactElement {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(props.form.setControlValue(event.target.name, event.target.value));
  };

  const handleSubmit = (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    props.onSubmit(props.form);
  };

  const agencyNameCtrl = props.form.controls.get("agencyName");
  const coordinatorEmailCtrl = props.form.controls.get("coordinatorEmail");
  const coordinatorPhoneCtrl = props.form.controls.get("coordinatorPhone");

  if (
    agencyNameCtrl === undefined ||
    coordinatorEmailCtrl === undefined ||
    coordinatorPhoneCtrl === undefined
  ) {
    throw new Error("All ContactAgency Form Controllers should defined");
  }

  return (
    <AppBottomSheet
      isOpen={props.isOpen}
      className="ContactAgencyBottomSheet"
      onRequestClose={props.onRequestClose}
    >
      <h2>{translate(STRINGS.OK_NO_PROBLEM)}</h2>
      <p>{translate(STRINGS.TELL_US_YOUR_AGENY_DESCRIPTION)}</p>
      <form onSubmit={handleSubmit}>
        <AppInput
          placeholder={translate(STRINGS.AGENCY_NAME)}
          color="white"
          name="agencyName"
          onBlur={handleChange}
          error={Validators.toTranslate(agencyNameCtrl.getFirstError())}
        />

        <AppInput
          placeholder={translate(STRINGS.COORDINATOR_EMAIL)}
          color="white"
          name="coordinatorEmail"
          onBlur={handleChange}
          error={Validators.toTranslate(coordinatorEmailCtrl.getFirstError())}
        />

        <AppInput
          placeholder={translate(STRINGS.COORDINATOR_PHONE)}
          color="white"
          name="coordinatorPhone"
          onBlur={handleChange}
          error={Validators.toTranslate(coordinatorPhoneCtrl.getFirstError())}
        />

        <AppButton type="submit" color="white" disabled={!props.form.isValid()}>
          {translate(STRINGS.NEXT)}
          <AppIcon icon={CHEVRON_RIGHT_SVG} stroke="green" />
        </AppButton>
      </form>
    </AppBottomSheet>
  );
}
